angular.module('unergie.main')
.controller('prmSearchBeginnerModalCtrl', ($scope, $uibModalInstance, ApiUser, BoFeaturesService, AlertManager, ErrorCatcher, is_a_move) => {
    $scope.is_a_move = is_a_move
    $scope.showTools = !BoFeaturesService.get('isEnvProd')

    $scope.statesMapping = {
        SERVC: 'En service',
        RESIL: 'Résilié',
        ECRES: 'En service, en cours de résiliation',
        ECRAC: 'En cours de raccordement',
        IMPRO: 'Improductif',
        INACCE: 'Inaccessible',
    }

    $scope.fillTestCase = (address, name) => {
        $scope.addressSearch = address
        $scope.search.address.num_street = address
        $scope.search.address.city = { post_code: '33000', city_code: '33063' }
        $scope.search.client.name = name
    }

    $scope.addressTooltip = `Ce champ de recherche s'appuie sur le référentiel national des adresses (adresse.data.gouv.fr).`

    $scope.close = $uibModalInstance.dismiss
    $scope.searching = false

    $scope.currentStep = 'chooseMode'
    $scope.invoiceBrand = 'edf'

    $scope.blocs = _.compact([
        is_a_move ? undefined : {
            label: 'Le prospect a une facture sous la main',
            icon: 'mode-facture',
            select: () => ($scope.currentStep = 'invoice'),
        },
        {
            label: is_a_move ? 'Le prospect a accès au compteur du nouveau logement (un linky)' : 'Le prospect a accès à son compteur (un linky)',
            icon: 'mode-compteur',
            select: () => ($scope.currentStep = 'meter'),
        },
        {
            label: is_a_move ? 'Rechercher avec sa nouvelle adresse' : 'Aucun : rechercher avec son adresse',
            icon: 'mode-search',
            select: () => ($scope.currentStep = 'search'),
        },
    ])

    $scope.search = {}

    $scope.reset = function (resultOnly) {
        if (!resultOnly) {
            $scope.addressSearch = undefined
            $scope.search.client = {
                category: undefined,
                name: undefined,
                siret: undefined,
            }
        }
        $scope.search.power_kind = undefined
        $scope.search.meter_number = undefined
        $scope.search.address = {}
        $scope.search.address.num_street = undefined
        $scope.search.address.detail = undefined
        $scope.search.address.city = {}
        $scope.search.address.city.post_code = undefined
        $scope.search.address.city.city_code = undefined
        $scope.search.out_of_perimeter = false
        $scope.coordinates = undefined
    }

    $scope.reset()

    // ADDRESS
    $scope.updateAddr = function (data) {
        $scope.search.address.city.post_code = data.addr_post_code
        $scope.search.address.city.city_code = data.addr_city_code
        $scope.search.address.num_street = data.addr_num_street
        $scope.coordinates = { x: data.addr_x, y: data.addr_y }
    }

    $scope.lookupAddr = function (addr) {
        $scope.reset(true)
        $scope.searching = true
        const p = ApiUser.lookupAddr({ q: addr }).$promise
        p.then(() => {
            $scope.searching = false
        }).catch(() => {
            $scope.searching = false
        })
        return p
    }

    const cleanEmpty = (obj) =>
        _.forEach(obj, (value, key) => {
            if (angular.isObject(value)) {
                return cleanEmpty(value)
            } else if ((value === null) || (value === '') || (value === undefined)) {
                return delete obj[key]
            }
        })

    $scope.canSearch = () => !!($scope.search.address.city.post_code && $scope.search.address.city.city_code) && (!$scope.search.client.name || $scope.search.client.name.length >= 3)

    $scope.searchPrm = function (v = 2) {
        cleanEmpty($scope.search)
        $scope.foundPrm = null
        $scope.errorCode = null
        $scope.searchingPrm = true
        return ApiUser.lookupPrm({ v, singleResult: true }, $scope.search).$promise.then((data) => {
            console.log('found', data[0])
            $scope.foundPrm = data[0]
        })
        .catch((error) => {
            let errorCode = _.get(error, 'data.data.code')
            if (errorCode === 'TOO_MANY_RESULTS' && !$scope.search.client.name) {
                errorCode = `TOO_MANY_RESULTS_NONAME`
            }
            switch (errorCode) {
                case 'TOO_MANY_RESULTS_NONAME':
                case 'TOO_MANY_RESULTS':
                case 'NO_RESULT':
                    $scope.errorCode = errorCode
                    break
                default:
                    ErrorCatcher(error)
            }
        })
        .finally(() => {
            $scope.searchingPrm = false
        })
    }

    // CHOOSE PRM
    $scope.choosePRM = (datum) => $uibModalInstance.close(datum.prm)
})
